
import { ExtraFieldBaseConfig } from "@/models/dossier-configs/extra-field-base-config";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ISelectItem } from "winfakt-vue-components";
import Vue from "vue";
import {ExtraFieldsType} from "@/utils/models/extra-fields";
import AppSaleTypeMultiSelect from "@/components/sales/SaleTypeMultiSelect.vue";

export const EXTRA_FIELD_TAB_TYPES:ExtraFieldsType[] = [
	ExtraFieldsType.CONTACT,
	ExtraFieldsType.PRODUCT,
	ExtraFieldsType.PURCHASE,
	ExtraFieldsType.CRM,
	ExtraFieldsType.PROJECT,
	ExtraFieldsType.CAR
];

export default Vue.extend({
	inject: {
		extraFieldTabs: {
			default: ():(()=>ExtraFieldTabConfig[]) => ()=>[]
		}
	},
	props: {
		value: {
			type: Object as ()=>ExtraFieldBaseConfig,
			required: true
		},
		extraFieldsType: {
			type: String as ()=>ExtraFieldsType,
			required: true
		}
	},
	computed: {
		isSaleType():boolean {
			return this.extraFieldsType == ExtraFieldsType.SALE;
		},
		supportsTabs():boolean {
			return EXTRA_FIELD_TAB_TYPES.indexOf(this.extraFieldsType) != -1;
		},
		tabItems():ISelectItem<string>[] {
			let tabs:ExtraFieldTabConfig[] = (this as any).extraFieldTabs();
			return [
				{text: this.$ct("extra-field-tab-default").toString(), value: ""},
				...tabs.map(t=>({text: t.Name || this.$ct("extra-field-tab-unnamed").toString(), value: t.ID}))
			];
		}
	},
	components: {
		AppSaleTypeMultiSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
